const splitPathAndSuffix = (value: string) => {
    const hashIndex = value.indexOf('#');
    const pathnameWithQuery = hashIndex >= 0 ? value.slice(0, hashIndex) : value;
    const hashSuffix = hashIndex >= 0 ? value.slice(hashIndex) : '';
    const queryIndex = pathnameWithQuery.indexOf('?');
    const pathname = queryIndex >= 0 ? pathnameWithQuery.slice(0, queryIndex) : pathnameWithQuery;
    const searchSuffix = queryIndex >= 0 ? pathnameWithQuery.slice(queryIndex) : '';

    return {
        pathname,
        suffix: `${searchSuffix}${hashSuffix}`,
    };
};

export const normalizeAppPath = (value: string | null | undefined) => {
    if (!value || !value.startsWith('/')) {
        return null;
    }

    if (value.startsWith('//')) {
        return null;
    }

    const { pathname, suffix } = splitPathAndSuffix(value);

    return `${pathname}${suffix}`;
};

export const getExternalAppPath = (path: string) => {
    const normalizedPath = normalizeAppPath(path);

    if (!normalizedPath) {
        return '/';
    }

    return normalizedPath;
};

export const getPublicAssetPath = (path: string) => getExternalAppPath(path.startsWith('/') ? path : `/${path}`);
